import { render, staticRenderFns } from "./modal2.vue?vue&type=template&id=0bbffa05&"
import script from "./modal2.vue?vue&type=script&lang=ts&"
export * from "./modal2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports